import React from 'react';
import { Node } from '@msdyn365-commerce-modules/utilities';
import { AccordionItem } from './details-accordion-item';
import { ICommerceApiSettings, IGridSettings } from '@msdyn365-commerce/core-internal';
import { AttributeValue } from '@msdyn365-commerce/retail-proxy';
import { IDobbiesBuyboxProductDetailsConfig } from '../../dobbies-buybox-product-details.props.autogenerated';

export interface IAccordionData {
    key: string;
    title: string;
    content: string;
}

export interface IAccordionProps {
    data: (IAccordionData | null)[];
    apiSettings: ICommerceApiSettings;
    gridSettings?: IGridSettings;
    keyFeaturesMeta?: AttributeValue;
    floweringTime?: string;
    isPFItem?: boolean;
    config: IDobbiesBuyboxProductDetailsConfig;
}

export function DetailsAccordion(props: IAccordionProps) {
    const { data, keyFeaturesMeta } = props;

    return (
        <Node className='ms-tabs__list details-accordion' tag='ul'>
            {data.map((item, i) => {
                return (
                    item && (
                        <AccordionItem
                            key={i}
                            index={i}
                            title={item.title}
                            value={item.content}
                            itemKey={item.key}
                            keyFeaturesMeta={keyFeaturesMeta}
                            apiSettings={props.apiSettings}
                            gridSettings={props.gridSettings}
                            floweringTime={props.floweringTime}
                            isPFItem={props.isPFItem}
                            config={props.config}
                        />
                    )
                );
            })}
        </Node>
    );
}
